<template>
  <div id="app">
    <div class="wrapper">
      <Header
        v-if="user"
        :style="'padding-left: 20%; padding-right: 20%; margin-left: 0 !important'"
      />
      <!--<Sidebar v-if="user" />-->
      <router-view />
    </div>
  </div>
</template>

<script>
// import SysUtils from '@/base/utils/SysUtils'
import Header from '@/components/organisms/OrHeader'
// import Sidebar from '@/components/organisms/OrSidebar'

export default {
  name: 'App',
  components: {
    Header
    // Sidebar
  },
  data () {
    let userToken = localStorage.getItem('fs_token')
    let userId = localStorage.getItem('fs_user_id')
    return {
      user_token: userToken,
      user_id: userId
    }
  },
  computed: {
    user () {
      if (this.$store.state.Auth.user) {
        return true
      }
      return false
    }
  },
  beforeCreate () {
    window.toasted = this.$toasted
  }
}
</script>

<style>
label:not(.form-check-label):not(.custom-file-label) {
  line-height: normal !important;
}
.modal-xl {
  max-width: 1140px !important;
}

.modal-fullscreen .modal-dialog {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen .modal-content {
  min-height: 100vh !important;
}
span.badge {
  line-height: normal !important;
}

.bg-green {
  background-color: #29AA73 !important;
}
.text-green {
  color: #415050 !important;
}
</style>
